import { FunctionComponent } from 'react';
import { Chip } from '@mui/material';
import { TicketDrawerLabel } from '../../ui/ticketDrawerContent/ticketDrawerLabel';
import { useGetTicketPermissionStatusQuery } from '../../api/ticket.api';

type PermissionStatusBlockProps = {
    ticketId: string;
};

export const PermissionStatusBlock: FunctionComponent<
    PermissionStatusBlockProps
> = ({ ticketId }) => {
    const { data, isLoading, error, isError } =
        useGetTicketPermissionStatusQuery({
            ticketId,
        });

    if (isLoading) {
        return <TicketDrawerLabel>-</TicketDrawerLabel>;
    }

    if (
        isError ||
        error ||
        !data ||
        !data.permissionStatuses ||
        data.permissionStatuses.length === 0
    ) {
        return <TicketDrawerLabel>-</TicketDrawerLabel>;
    }

    return (
        <>
            {data.permissionStatuses.map((status, index) => (
                <Chip
                    key={index}
                    label={status}
                    color='primary'
                    sx={{
                        mr: 1,
                        mb: 1,
                    }}
                />
            ))}
        </>
    );
};
